import { UsersHeaders } from '../../../utils/headers';
import ActionsMenu from '../components/ActionsMenu';
import DataTable from '../../../components/Table/DataTable';
import SearchToolbar from '../../../components/SearchToolbar/SearchToolbar';
import useUsers from './hooks/useUsers';
import UserDrawerSave from './UsersSave/UserDrawerSave';
import UserDrawerShow from './UserShow/UserDrawerShow';

function UsersIndex() {
    const {
        users,
        anchorEl,
        loadingUsers,
        fetchingUsers,
        btnSelectStyle,
        filterModelValue,
        deletingUser,
        handleCloseMenu,
        handleSubmitAction,
        handleOpenDrawer,
        onInputChange,
        handleMenuAction,
        ...props
    } = useUsers();

    return (
        <>
            <SearchToolbar
                inputLabel="Buscar"
                btnText="Nuevo usuario"
                onButtonClick={() => handleOpenDrawer('new')}
                onInputChange={onInputChange}
            />
            <DataTable
                headers={UsersHeaders}
                handleMenuAction={handleMenuAction}
                withActions={['menu']}
                loading={loadingUsers || fetchingUsers || deletingUser}
                options={users}
                filterModelValue={filterModelValue}
                customStyles={{
                    [`${btnSelectStyle}`]: {
                        background: '#E2ECF3',
                        borderRadius: '2px !important'
                    }
                }}
            />
            <ActionsMenu
                anchorEl={anchorEl}
                handleCloseMenu={handleCloseMenu}
                handleSubmitAction={handleSubmitAction}
            />

            <UserDrawerSave {...props} />

            <UserDrawerShow {...props} />
        </>
    );
}

export default UsersIndex;
